import { render, staticRenderFns } from "./TvMode.vue?vue&type=template&id=4de69059&scoped=true"
import script from "./TvMode.vue?vue&type=script&lang=js"
export * from "./TvMode.vue?vue&type=script&lang=js"
import style0 from "./TvMode.vue?vue&type=style&index=0&id=4de69059&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de69059",
  null
  
)

export default component.exports